import styled from 'styled-components'
import { breakpoint } from '../../layout/mixins'

export const Button = styled.button`
  background-color: ${({ theme }) => theme.themeColorWhite};
  border-radius: ${({ theme }) => theme.borderRadius};
  border: 0;
  box-shadow: 1px 1px 2px 0 rgba(0,0,0,.1);
  color: ${({ theme }) => theme.themeColorPale};
  padding: ${({ theme }) => theme.gutterSmall} ${({ theme }) => theme.gutter};
  padding-right: calc(${({ theme }) => theme.gutter} * 4);
  font-size: 1em;
  line-height: ${({ theme }) => theme.lineHeightRegular};
  width: 100%;
  text-align: left;
  background-image: url("data:image/svg+xml;utf8,<svg width='28' height='28' xmlns='http://www.w3.org/2000/svg' ><path d='M27 14h0a13 13 0 01-13 13h0A13 13 0 011 14h0A13 13 0 0114 1h0a13 13 0 0113 13z' fill='%23a7b5bc' stroke='%23a7b5bc' stroke-width='2' fill-rule='evenodd'/><path d='M19.48 16.6a.54.54 0 000-.76.59.59 0 00-.82 0l-4.2 4V6.56a.57.57 0 00-.58-.56.57.57 0 00-.59.55v13.28l-4.19-4a.6.6 0 00-.83 0 .54.54 0 000 .76l5.19 5a.59.59 0 00.82 0z' fill='%23fff'/></svg>");
  background-position: calc(100% - 10px) 50%;
  background-size: 1em 1em;
  background-repeat: no-repeat;
  border: 2px solid transparent;

  ${(props) => props.changed && `
    color: ${props.theme.themeColorPrimary};
  `}

  ${(props) => props.open && `
    color: ${props.theme.themeColorPrimary};
    box-shadow: 2px 2px 4px 0 rgba(0,0,0,.2);
    text-decoration: underline;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  `}

  ${(props) => props.required && props.valid && !props.open && `
    .under-validation & {
      border: 2px solid ${props.theme.themeColorAccent};
      box-shadow: none;
    }
  `}

  ${(props) => props.required && !props.valid && !props.open && `
  .under-validation & {
    border: 2px solid ${props.theme.themeColorError};
    box-shadow: none;
  }
`}
`

export const ButtonText = styled.span`
  overflow: hidden;
  width: 100%;
  display: block;
  white-space: nowrap;
`

export const ListContainer = styled.div`
  background: #fff;
  display: none;
  position: absolute;
  z-index: 100;
  width: 100%;
  box-shadow: 2px 5px 4px 0 rgba(0,0,0,.2);
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius};
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius};
  ${(props) => props.open && `
    display: block;
  `}
`

export const List = styled.ul`
  margin: 0;
  list-style-type: none;
`

export const Container = styled.div`
  width: 100%;
  position: relative;
  margin-bottom: ${({ theme }) => theme.gutter};
  
  &:last-child {
    margin-bottom: 0;
  }

  ${breakpoint.up('tablet')`
    margin-bottom: 0;
    ${({ half, theme }) => half && `
      width: calc(50% - ${theme.gutter});
    `}

    ${({ third, theme }) => third && `
      width: calc(33.33% - ${theme.gutter});
    `}
  `}
`
export const HiddenInput = styled.input`
  position: absolute !important;
  height: 43px; 
  width: 1px;
  overflow: hidden;
  clip: rect(1px 1px 1px 1px);
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap;
  pointer-events: none;
  top: 0px;
  opacity: 0;
`